import { render } from "./UserSessionHistory.vue?vue&type=template&id=63ca4f9b&ts=true"
import script from "./UserSessionHistory.vue?vue&type=script&lang=ts"
export * from "./UserSessionHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__